<div class="activate row">
  <div class="activate col-md-12">
    <div class="row">
      <div class="col-md-12">
        <h2>Almost done!</h2>
        <h3>Please create a user account to manage your application.</h3>
        <br>
        </div>
      </div>
      <div class="row account-form">
        @if (accountForm) {
          <form [formGroup]="accountForm" autocomplete="off">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>User Name</mat-label>
                    <input
                      matInput
                      id="displayName"
                      name="displayName"
                      formControlName="displayName"
                      placeholder="Enter user name"
                      type="email"
                      required blockHtmlChars >
                      @if (accountForm.get('displayName').touched && accountForm.get('displayName').errors) {
                        <mat-error
                          >
                          Display Name is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline">
                      <mat-label>Confirmation Email Code</mat-label>
                      <input
                        matInput
                        id="emailCode"
                        formControlName="emailCode"
                        placeholder="Enter confirmation email code"
                        type="text"
                        autocomplete="off"
                        required trim="blur" homeownerBlockSpecialChars/>
                        @if (accountForm.get('emailCode').touched && accountForm.get('emailCode').errors) {
                          <mat-error
                            >
                            Email Code is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 error-messages">
                      <small>
                        @if (emailSendError) {
                          <div
                            style="color: #ad2c23;"
                            >
                            There was an error in sending the verification email. Please try again.
                          </div>
                        }
                        @if (!delayInterval) {
                          <span>We sent you an email with a code to validate that you are the owner of the email account.
                            Please enter that code above. If you did not get a code, please
                            <a
                              [attr.href]="(requestCounter > 2 || requesting) ? null : '#'"
                              (click)="requestCounter <= 2 && !requesting && requestNewCode($event)"
                            >Request New Code</a>.
                          </span>
                        }
                        @if (delayInterval) {
                          <span><strong>There have been too many requests to verify this email address. Please wait 5 minutes to receive the email before trying again.</strong></span>
                        }
                        <br />
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input
                          matInput
                          id="password"
                          formControlName="password"
                          placeholder="Enter password"
                          type="password"
                          autocomplete="off"
                          required blockHtmlChars/>
                          @if (accountForm.get('password').touched && accountForm.get('password').errors && accountForm.get('password').errors.required) {
                            <mat-error
                              >
                              Password is required
                            </mat-error>
                          }
                          @if (accountForm.get('password').touched && accountForm.get('password').errors
                            && (accountForm.get('password').errors.minlength || accountForm.get('password').errors.pattern)) {
                            <mat-error
                              >
                              Password must meet all requirements.
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12">
                            <mat-form-field appearance="outline">
                              <mat-label>Confirm Password</mat-label>
                              <input
                                matInput
                                formControlName="confirmPassword"
                                placeholder="Confirm password"
                                id="confirmPassword"
                                type="password"
                                autocomplete="off"
                                [errorStateMatcher]="passwordMatcherEmail"
                                required blockHtmlChars/>
                                @if (accountForm.get('confirmPassword').touched && accountForm.get('confirmPassword').errors && accountForm.get('confirmPassword').errors.required) {
                                  <mat-error
                                    >
                                    Please re-enter your password
                                  </mat-error>
                                }
                                @if (accountForm.get('confirmPassword').touched && accountForm.errors?.password) {
                                  <mat-error
                                    >
                                    Passwords do not match
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <small>
                                Password must be 8 or more characters and at least one of each of the following from the list provided below:
                                <ul>
                                  <li>Uppercase letter (A-Z)</li>
                                  <li>Lowercase letter (a-z)</li>
                                  <li>Digit (0-9)</li>
                                  <li>Special character (~`!&#64;#$%^)</li>
                                </ul>
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                }
              </div>
              @if (messageDisplay) {
                <div class="row">
                  <div style="color: #ad2c23;" class="col-md-12">
                    {{ messageDisplay }}@if (messageDisplayShowLogout) {
                    <span>, Please <a href (click)="logout($event)">Logout</a> to complete registration using that account.</span>
                  }
                </div>
              </div>
            }
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  matStepperPrevious
                  id="go-back-button"
                  mat-button>
                  GO BACK
                </button>
                <button
                  mat-raised-button
                  class="complete float-right" color="primary"
                  [disabled]="!continueEnabled()"
                  (click)="submitAccount()"
                  id="complete-button"
                  type="button">

                  <div style="display: flex; align-items: center;">

                    <span>COMPLETE</span>
                    @if (isloading) {
                      <mat-spinner diameter="20" class="spinner"></mat-spinner>
                    }
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

